<svg><use [attr.xlink:href]="path"></use></svg>